import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useScrollTopOnRouteChange() {
  const location = useLocation();

  useLayoutEffect(() => {
    if (DO_NOT_SCROLL_TOP_PATH.includes(location.pathname)) return;

    // Scroll to the top of the page when the route changes
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname]);
}

const DO_NOT_SCROLL_TOP_PATH = [
  '/campagne/depots/vue-siret',
  '/campagne/depots/vue-siren',
];